import authHeader from "./auth-header";
import instance from "./ApiServices";
const getAll = () => {
  return instance.get("/social", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/social/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/social", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/social/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/social/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/social`);
};

const findByTitle = (title) => {
  return instance.get(`/social?title=${title}`);
};

const SocailService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default SocailService;
